
import {
    ColumnBib,
    ColumnName,
    ColumnResult,
    ColumnNoc,
    ColumnExpander,
    ColumnStartTime
} from "components/common/TableColumns"



export function TableColumns() {

    return (
        [
            ColumnBib({ label: "HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResult({ label: "" }),
            ColumnExpander({ type: 'alwaysTrueTri' })

        ]
    )
}

export function TableColumnsParasEventsPTVPTW() {

    return (
        [
            ColumnBib({ label: "HeaderRaceNo" }),
            ColumnStartTime({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResult({ label: "" }),
            ColumnExpander({ type: 'alwaysTrueTri' })

        ]
    )
}

export function TableColumnsSM() {

    return (
        [
            ColumnBib({ label: "HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResult({ label: "" }),
            ColumnExpander({ type: 'alwaysTrueTri' })

        ]
    )
}

export function TableColumnsSMParasEventsPTVPTW() {

    return (
        [
            ColumnBib({ label: "HeaderRaceNo" }),
            ColumnStartTime({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResult({ label: "" }),
            ColumnExpander({ type: 'alwaysTrueTri' })

        ]
    )
}

export default TableColumns
